/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  TextMessageMC,
  AudioMessageMC,
  ImageMessageMC,
  QuickReplyMessageMC,
  OrderWsMessageMC,
  ProductWsMessageMC,
  DocumentMessageMC,
  StickerMessageMC,
  LocationMessageMC,
  VideoMessageMC,
  ContactMessageMC,
  ListMessageMC,
  NoteMessageMC,
  OrderNoteMessageMC,
  MiaInternalMessageMC,
  RepliedTextMessageMC,
  RepliedImageMessageMC,
  RepliedAudioMessageMC,
  RepliedVideoMessageMC,
  RepliedLocationMessageMC,
  RepliedDocumentMessageMC,
  RepliedContactMessageMC,
  RepliedStickerMessageMC,
  RepliedOrderWsMessageMC,
  RepliedProductWsMessageMC,
  MiaEventMessageMC,
  CarouselMessageMC,
  RepliedCarouselMessageMC,
  CallPermissionReplyMessageMC,
  PostMessageMC,
  RepliedPostMessageMC,
  FlowMessageMC
} from '../components';

const componentMap = {
  TextMessageMC,
  AudioMessageMC,
  ImageMessageMC,
  QuickReplyMessageMC,
  OrderWsMessageMC,
  ProductWsMessageMC,
  DocumentMessageMC,
  StickerMessageMC,
  LocationMessageMC,
  VideoMessageMC,
  ContactMessageMC,
  ListMessageMC,
  NoteMessageMC,
  OrderNoteMessageMC,
  MiaInternalMessageMC,
  RepliedTextMessageMC,
  RepliedImageMessageMC,
  RepliedAudioMessageMC,
  RepliedVideoMessageMC,
  RepliedLocationMessageMC,
  RepliedDocumentMessageMC,
  RepliedContactMessageMC,
  RepliedStickerMessageMC,
  RepliedOrderWsMessageMC,
  RepliedProductWsMessageMC,
  MiaEventMessageMC,
  CarouselMessageMC,
  RepliedCarouselMessageMC,
  CallPermissionReplyMessageMC,
  PostMessageMC,
  RepliedPostMessageMC,
  FlowMessageMC
};

export default function renderMessage({ message, ...rest }) {
  const Component = componentMap[message.componentType];
  if (!Component) return null;
  return <Component message={message} {...rest} />;
}
